import { useContext } from 'react';
import { BLEContext } from '../context/BLEContext';

const useBLE = () => {
  const ble = useContext(BLEContext);

  return ble;
};
export default useBLE;
